module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18KAX3i/tc-custom/9781460332139.jpg?1740294351126",
      "alt": "This image is the cover for the book Double Agent"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Double Agent\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this inspirational romantic suspense, a female government agent partners with a special forces officer to find her brother’s murderer.")]), _c('br'), _c('br'), _vm._v("As a spy, Sabine Laduca works alone. But when she investigates her brother’s murder, she’s forced into an uneasy alliance with his Delta Force team leader. The CIA taught Sabine to trust no one, and Sergeant Major Doug Richardson is no exception. The handsome soldier hides his own secrets, but nothing will stop Sabine from finding out who killed her brother. Not even when the CIA declares her rogue. Now not only is the killer after her, so is the agency. For the first time, she needs someone—Doug. Because only he can help her find the truth . . . and only he can keep her safe . . . . "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lisa Phillips\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A British ex-pat, Lisa loves high-stakes stories of mayhem and disaster where you can find made-for-each-other love that always ends in happily ever after. Lisa leads worship with her husband at their church. They have two kids and an all-black Airedale.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0